// @ts-expect-error -- Suppresses TS and ESLint errors.
type _ = Types.Scalars;
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import type * as Types from '../util-types.js';

export type PublicSitePageQueryVariables = Types.Exact<{
  siteId: Types.Scalars['String']['input'];
  path: Types.Scalars['String']['input'];
}>;

export type PublicSitePageQuery = {
  publicSite?: {
    __typename: 'PublicSite';
    id: string;
    page?: {
      __typename: 'PublicSitePage';
      id: string;
      title: string;
      metaTitle?: string | null;
      metaDescription?: string | null;
      metaRobots: Array<string>;
      metaImageUrl?: string | null;
      featuredImageUrl?: string | null;
      components: string;
      bodyStyles?: string | null;
      props?: string | null;
      resolvedLayout?: {
        __typename: 'Layout';
        id: string;
        pathPrefix?: string | null;
        components: string;
      } | null;
    } | null;
  } | null;
};

export const PublicSitePageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PublicSitePage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'siteId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'path' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'publicSite' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'siteId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'page' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'path' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'path' } },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'metaTitle' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'metaDescription' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'metaRobots' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'metaImageUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'featuredImageUrl' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'resolvedLayout' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'pathPrefix' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'components' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'components' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'bodyStyles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'props' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PublicSitePageQuery, PublicSitePageQueryVariables>;
